import { Box, Link, ProfileImage, Skeleton, Svg, Text } from '@hopskipdrive/react-components';

import { colorTokens } from '../../../shared/components/variables';
import { DriverDetails } from '../../types/driver';
import { capitalizePronouns } from '../../utils/helpers/name';

interface IDriverAndVehiclePhotos {
  driverDetails: DriverDetails;
  isFetching: boolean;
}

export const DriverPersonalInfo: React.FC<IDriverAndVehiclePhotos> = ({ driverDetails, isFetching }) => {
  return (
    <>
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="flex-end"
        gap={driverDetails?.vehicleInformation?.photoUrl ? '0' : '55px'}
      >
        {isFetching ? (
          <Skeleton data-testid="main-heading-skeleton" variant="circular" width={92} height={92} />
        ) : (
          <>
            <ProfileImage imgSrc={driverDetails?.profilePhotoUrl || ''} size={92} />
            {driverDetails?.vehicleInformation?.photoUrl ? (
              <img src={driverDetails?.vehicleInformation?.photoUrl} alt="Driver vehicle" style={{ height: '69px' }} />
            ) : (
              <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center" maxWidth="72px">
                <Box>
                  <Svg icon="cross" style={{ color: colorTokens.text.secondary }} />
                  <Text variant="body2" textColor="secondaryText">
                    No Vehicle Image
                  </Text>
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
      <Box mb={3}>
        {isFetching ? (
          <>
            <Skeleton variant="text" width={135} height={32} />
            <Skeleton variant="text" width={130} height={24} />
          </>
        ) : (
          <>
            <Link
              target="_blank"
              variant="h5"
              underline="hover"
              href={driverDetails.adminUrl}
              style={{ color: colorTokens.text.primary, fontWeight: 500 }}
            >
              {`${driverDetails?.firstName} ${driverDetails?.lastName}`}
            </Link>
            <Text variant="body1" fontWeight={400}>
              ({capitalizePronouns(driverDetails?.pronouns || '')})
            </Text>
          </>
        )}
      </Box>
    </>
  );
};
